import { useEffect } from "react";
import { useParams } from "react-router-dom";
import DeliverySection from "../components/Delivery";
import { useTranslation } from "react-i18next";
import SubCategoryComponent from "../components/SubCategory";

const SubCategoryPage = () => {
  const { categoryId } = useParams();

  const { i18n } = useTranslation();

  // Direction control
  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-[#f2e6db] py-4 sm:py-6 lg:py-8">
      <SubCategoryComponent categoryId={categoryId} />

      <DeliverySection />

      <style>
        {`
          .carousel-wrapper {
            position: relative;
            width: 100%;
            margin: 30px 0;
            display: flex;
            align-items: center;
          }

          .carousel-container {
            display: flex;
            overflow-x: auto;
            scroll-behavior: smooth;
            gap: 20px;
            padding: 10px;
            scrollbar-width: none; /* Firefox */
          }
          .carousel-container::-webkit-scrollbar {
            display: none; /* Chrome */
          }

          .carousel-card {
            min-width: 260px;
            transition: transform 0.3s ease, opacity 0.3s ease;
            animation: fadeInUp 0.5s ease forwards;
            opacity: 0;
          }
          @keyframes fadeInUp {
            0% { transform: translateY(20px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }

          .carousel-btn {
            background: #000000aa;
            color: white;
            border: none;
            padding: 12px 18px;
            font-size: 22px;
            cursor: pointer;
            border-radius: 50%;
            position: absolute;
            z-index: 5;
            top: 50%;
            transform: translateY(-50%);
            transition: 0.3s ease;
          }
          .carousel-btn:hover {
            background: #000;
          }

          .carousel-btn.prev {
            left: 0;
          }
          .carousel-btn.next {
            right: 0;
          }
        `}
      </style>
    </div>
  );
};

export default SubCategoryPage;
